import * as React from 'react';
import CreateCaseRunCompact, { ICreateCaseRunCompactProps } from './CreateCaseRunCompact';

export default function useCreateCaseRunCompact(props: Omit<ICreateCaseRunCompactProps, 'onCancel' | 'onSuccess'> & Partial<Pick<ICreateCaseRunCompactProps, 'onSuccess' | 'onCancel'>>) {
    const ref = React.useRef<any>(null);
    const [, setVersion] = React.useState(0); // used to force re-render when element changes

    // Recreate element when props change (e.g., referenceId)
    const element = React.useMemo(() => {
        return <CreateCaseRunCompact ref={ref as any} {...props} />;
    }, [props]);

    const show = React.useCallback(async () => {
        if (ref.current && typeof ref.current.open === 'function') {
            await ref.current.open();
            setVersion(v => v + 1);
        }
    }, [ref]);

    const close = React.useCallback(() => {
        if (ref.current && typeof ref.current.close === 'function') {
            ref.current.close();
            setVersion(v => v + 1);
        }
    }, [ref]);

    return { element, show, close } as {
        element: React.ReactElement,
        show: () => Promise<void>,
        close: () => void,
    };
}
